import { CONSENT_ACTION, CONSENT_STORAGE_KEY } from '../../constants'
import { updateAnalyticsConsentUtil } from '../../utils/update-analytics-consent'
import { logUtil } from 'packages/src'

export const grantAllConsentAction = () => {
  return (dispatch) => {
    const logger = logUtil('consent:grantAll')
    logger.info('User accepted all cookies')

    const consentData = {
      analytics: true,
      marketing: true,
      preferences: true,
      timestamp: new Date().toISOString()
    }

    // Store in localStorage
    try {
      if (window.localStorage) {
        window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consentData))
        logger.debug('Consent preferences saved to localStorage')
      } else {
        logger.warn('localStorage not available, consent will not persist')
      }
    } catch (error) {
      logger.error('Failed to save consent preferences:', error)
    }

    // Update analytics tools
    updateAnalyticsConsentUtil({
      analytics: true,
      marketing: true,
      preferences: true
    })

    dispatch({
      type: CONSENT_ACTION.GRANT_ALL
    })
    logger.info('GRANT_ALL action dispatched')
  }
}
